import { useMemo } from 'react'
import Map, { NavigationControl } from 'react-map-gl/maplibre'

interface EventMap3DProps {
  lat: number
  lng: number
  label?: string
}

/** Satellite imagery style for Location View (ESRI World Imagery) */
const SATELLITE_STYLE = {
  version: 8 as const,
  sources: {
    'esri-satellite': {
      type: 'raster' as const,
      tiles: [
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      ],
      tileSize: 256,
      attribution: '© Esri',
    },
  },
  layers: [
    { id: 'esri-satellite', type: 'raster' as const, source: 'esri-satellite' },
  ],
}

export default function EventMap3D({ lat, lng, label }: EventMap3DProps) {
  const center = useMemo(
    () => ({
      longitude: lng,
      latitude: lat,
      zoom: 6,
      pitch: 55,
      bearing: -30,
    }),
    [lat, lng]
  )

  return (
    <div className="mt-2 rounded border border-green-900/50 overflow-hidden bg-black/60 shadow-[0_0_12px_rgba(34,197,94,0.08)]">
      <div className="flex items-center justify-between px-3 py-1.5 border-b border-green-900/40 bg-gray-950/80">
        <span className="text-[9px] font-mono uppercase tracking-[0.15em] text-green-400 drop-shadow-[0_0_4px_rgba(74,222,128,0.3)]">
          Location View (Satellite)
        </span>
        {label && (
          <span className="text-[9px] text-gray-500 font-mono truncate max-w-[60%]">
            {label}
          </span>
        )}
      </div>
      <div className="h-52 relative">
        <Map
          initialViewState={center}
          mapStyle={SATELLITE_STYLE}
          style={{ width: '100%', height: '100%' }}
          attributionControl={false}
        >
          <NavigationControl position="top-right" visualizePitch />
          <div
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              width: 14,
              height: 14,
              borderRadius: '999px',
              border: '2px solid #22c55e',
              boxShadow: '0 0 12px rgba(34,197,94,0.9)',
              background: 'rgba(15,23,42,0.8)',
            }}
          />
        </Map>
      </div>
    </div>
  )
}

